import React from 'react';
import MessengerCustomerChat from "react-messenger-customer-chat";
const Messenger = () => {
    return (
        <div>
             <MessengerCustomerChat
            pageId="101895019292258"
            appId="2086600954844655"
            
      />
     
        </div>
    );
};

export default Messenger;